// config.js (Firebase v9 modular version)
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCtqjyJABj8RS0Ji8G7nk0on_nwqh0xZGU",
  authDomain: "vynta-capitals.firebaseapp.com",
  databaseURL: "https://vynta-capitals-default-rtdb.firebaseio.com",
  projectId: "vynta-capitals",
  storageBucket: "vynta-capitals.firebasestorage.app",
  messagingSenderId: "204534306142",
  appId: "1:204534306142:web:f6d3ff150e47246edd2bcf"
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Export the needed services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };

